import Page from 'src/player/sdk/embed/index';

export default Page;
